import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/workOrder', // 工单
  name: 'workOrder',
  permission: 'workorder',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.workOrder',
    requiresAuth: true,
    icon: 'icon-file',
    order: 1,
    permission: 'workorder',
  },
  children: [
    {
      path: 'workOrderManage', // The midline path complies with SEO specifications
      name: 'workOrderManage',
      permission: 'workorder:list',
      component: () => import('@/views/workOrder/index.vue'),
      meta: {
        locale: 'menu.workOrderManage',
        requiresAuth: true,
        roles: ['*'],
        permission: 'workorder:list',
      },
    },
    {
      path: 'workOrderList', // The midline path complies with SEO specifications
      name: 'workOrderList',
      permission: 'workorder:item',
      component: () => import('@/views/workOrder/order/index.vue'),
      meta: {
        locale: 'menu.workOrderList',
        requiresAuth: true,
        roles: ['*'],
        permission: 'workorder:item',
      },
    },
     {
      path: 'settlement', // The midline path complies with SEO specifications
      name: 'settlement',
      permission: 'workorder:settle',
      component: () => import('@/views/workOrder/settlement/index.vue'),
      meta: {
        locale: 'menu.settlement',
        requiresAuth: true,
        roles: ['*'],
        permission: 'workorder:settle',
      },
    },
  ],
};

export default LIST;
